module.exports = __webpack_public_path__ + "static/media/clapper.9b8a8742.webp";